import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getDateDaysAgo, convertToEasternISO } from '../../../../utils/dateFormatter'
import useDidMountEffect from '../../../../utils/useDidMountEffect'
import { getAllCurrenciesStart } from '../../../../store/redux-slices/currencies'
import { getSuperAdminSportsBookTransactionsStart } from '../../../../store/redux-slices/superAdminTransactions'
import { getLoginToken } from '../../../../utils/storageUtils'
import { getFileRequest } from '../../../../utils/axios'
import { toast } from '../../../../components/Toast'
import { getDateRangeByFilter, defaultDateFilter } from '../../../../utils/helpers';


const useCasinoTransactionsList = (props) => {
  const { playerData } = props;
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isInitialRender = useDidMountEffect()

  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [selectedAction, setSelectedAction] = useState('all')
  const [selectedslipStatus, setselectedslipStatus] = useState('all')
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [status, setStatus] = useState('all')
  const [search, setSearch] = useState('')
  const [searchbetSlip, setSearchBetSlip] = useState('')
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const { allCurrencies } = useSelector((state) => state.currencies)
  const { loading, casinoTransactions, sportsBookTransactions } = useSelector((state) => state.superAdminTransactions)
  const totalPages = Math.ceil(sportsBookTransactions?.count / limit)
  const totalCount = sportsBookTransactions?.count
  const [selectedFilter, setSelectedFilter] = useState(defaultDateFilter);


  // const [state, setState] = useState([
  //   {
  //     startDate: null,
  //     endDate: null,
  //     key: 'selection'
  //   }
  // ])

  const [state, setState] = useState(() => {
    const { startDate, endDate } = getDateRangeByFilter(defaultDateFilter);
    return [
      {
        startDate,
        endDate,
        key: "selection"
      }
    ];
  });


  useEffect(() => {
    dispatch(getAllCurrenciesStart({ limit: '', pageNo: '' }))
  }, [])

  useEffect(() => {
    if (!isInitialRender) {
      const startDate = state.map(a => a.startDate)[0]
      const endDate = state.map(a => a.endDate)[0]

      dispatch(getSuperAdminSportsBookTransactionsStart({
        limit,
        pageNo: page,
        email: search.replace('+', '%2B'),
        startDate: convertToEasternISO(startDate, 0, 0, 0, 0),
        endDate: convertToEasternISO(endDate, 23, 59, 59, 999),
        currencyCode: selectedCurrency,
        transactionType: selectedAction,
        betslipStatus: selectedslipStatus,
        tenantId: selectedPortal,
        adminId: selectedClient,
        status,
        userId: '',
        eventSearch: searchbetSlip,
        userId: playerData?.userId
      }))
    }
  }, [page, playerData?.userId])

  useEffect(() => {
    setPage(1)
    const startDate = state.map(a => a.startDate)[0]
    const endDate = state.map(a => a.endDate)[0]

    dispatch(getSuperAdminSportsBookTransactionsStart({
      limit,
      pageNo: 1,
      email: search.replace('+', '%2B'),
      startDate: convertToEasternISO(startDate, 0, 0, 0, 0),
      endDate: convertToEasternISO(endDate, 23, 59, 59, 999),
      currencyCode: selectedCurrency,
      transactionType: selectedAction,
      betslipStatus: selectedslipStatus,
      tenantId: selectedPortal,
      adminId: selectedClient,
      status,
      userId: '',
      eventSearch: searchbetSlip,
      userId: playerData?.userId
    }))
  }, [limit, selectedPortal, selectedCurrency, selectedAction, selectedslipStatus, state, status, selectedClient])

  const onResetDateFiltered = () => {
    setSelectedFilter(defaultDateFilter)
    const { startDate, endDate } = getDateRangeByFilter(defaultDateFilter);
    setState([
      {
        startDate,
        endDate,
        key: "selection"
      }
    ]);
  }
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        const startDate = state.map(a => a.startDate)[0]
        const endDate = state.map(a => a.endDate)[0]

        if (page === 1) {
          dispatch(getSuperAdminSportsBookTransactionsStart({
            limit,
            pageNo: page,
            email: search.replace('+', '%2B'),
            startDate: convertToEasternISO(startDate, 0, 0, 0, 0),
            endDate: convertToEasternISO(endDate, 23, 59, 59, 999),
            currencyCode: selectedCurrency,
            transactionType: selectedAction,
            betslipStatus: selectedslipStatus,
            tenantId: selectedPortal,
            adminId: selectedClient,
            status,
            userId: '',
            eventSearch: searchbetSlip,
            userId: playerData?.userId
          }))
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search, searchbetSlip])

  const getCsvDownloadUrl = () => {
    const startDate = state.map(a => a.startDate)[0];
    const endDate = state.map(a => a.endDate)[0];

    const params = new URLSearchParams({
      csvDownload: true,
      currencyCode: selectedCurrency,
      transactionType: selectedAction,
      betslipStatus: selectedslipStatus,

      eventSearch: searchbetSlip,
      email: search,
      adminId: selectedClient,
      token: getLoginToken()
    });

    if (startDate) {
      const startDateEST = convertToEasternISO(startDate, 0, 0, 0, 0);
      params.append("startDate", startDateEST);
    }

    if (endDate) {
      const endDateEST = convertToEasternISO(endDate, 23, 59, 59, 999);
      params.append("endDate", endDateEST);
    }

    return `${process.env.REACT_APP_API_URL}/api/admin/sportsbook/transactions?${params.toString()}`;
  };




  const handleDownload = async (format = 'csv', transactionType) => {
    try {
      const response = await getFileRequest(getCsvDownloadUrl());

      const blob = new Blob([response.data], { type: 'text/csv' });
      const downloadUrl = URL.createObjectURL(blob);

      const element = document.createElement('a');
      element.href = downloadUrl;
      element.download = `${transactionType}s_${format}_${new Date().toISOString().split('T')[0]}.csv`;
      element.style.display = 'none';

      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

      URL.revokeObjectURL(downloadUrl);

      toast(`CSV downloaded successfully`, 'success');
    } catch (error) {
      console.error('Download error:', error);
      toast('Error downloading CSV', 'error');
    }
  };
  console.log({ sportsBookTransactions }, "sportsBookTransactionssportsBookTransactions")
  return {
    allCurrencies,
    setSelectedCurrency,
    setSearch,
    setLimit,
    setPage,
    totalPages,
    limit,
    page,
    setSelectedAction,
    setselectedslipStatus,
    navigate,
    selectedCurrency,
    selectedAction,
    selectedslipStatus,
    search,
    state,
    setState,
    sportsBookTransactions,
    loading,
    status,
    setStatus,
    selectedClient,
    selectedPortal,
    setSelectedClient,
    setSelectedPortal,
    getCsvDownloadUrl,
    handleDownload,
    setSearchBetSlip,
    searchbetSlip,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    totalCount
  }
}

export default useCasinoTransactionsList
